import { render, staticRenderFns } from "./TestSideList.vue?vue&type=template&id=53fefb47&scoped=true&"
import script from "./TestSideList.vue?vue&type=script&lang=js&"
export * from "./TestSideList.vue?vue&type=script&lang=js&"
import style0 from "./TestSideList.vue?vue&type=style&index=0&id=53fefb47&lang=scss&scoped=true&"
import style1 from "./TestSideList.vue?vue&type=style&index=1&id=53fefb47&lang=scss&scoped=true&"
import style2 from "./TestSideList.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fefb47",
  null
  
)

export default component.exports